<script setup lang="ts">
import { computed } from 'vue';
import type { RecipeDetailResponse } from '~~/server/api/kiwi_user/recipes/detail';

const props = defineProps<{
  recipeData?: RecipeDetailResponse | null;
}>();

const recipeCategoryName = computed(() => {
  return props.recipeData?.categories.find(
    (category) => category.id === props.recipeData?.recipe_category_id,
  )?.name;
});
</script>

<template>
  <div>
    <OrganismsRecipeSearchForm class="mb-5" />
    <div class="bg-white border border-b-2 border-cream-500 rounded p-4 mb-5">
      <OrganismsRecipeDetailContent :recipe-data="recipeData" />
    </div>

    <div class="max-md:px-2">
      <AtomsAssociatedTagsSection
        v-if="recipeData?.associated_tags"
        :tags="recipeData.associated_tags"
        class="mb-10"
        title="関連するレシピの特徴から探す"
        link-base-path="/public/article/recipe"
      />

      <div v-if="recipeData?.same_category_recipes.length" class="my-10">
        <h2 class="text-brown-300 text-xl font-bold mb-3">
          「{{ recipeCategoryName }}」のレシピ
        </h2>

        <div class="grid grid-cols-2 md:grid-cols-4 gap-3 items-stretch mb-5">
          <AtomsRecipeCard
            v-for="recipe in recipeData?.same_category_recipes"
            :key="recipe.id"
            :old-identifier="recipe.old_identifier"
            :recipe-id="recipe.id"
            :filename="recipe.main_image"
            :energy="recipe.energy"
            :title="recipe.title"
            :tags="recipe.tags"
          />
        </div>

        <div class="text-right">
          <NuxtLink
            :to="`/public/article/recipe?ct=${recipeData?.recipe_category_id}`"
            class="text-brown-300 underline"
          >
            「{{ recipeCategoryName }}」のレシピをすべて見る
          </NuxtLink>
        </div>
      </div>

      <div v-if="recipeData?.related_recipes_by_menu.length" class="my-10">
        <h2 class="text-brown-300 text-xl font-bold mb-1">レシピ組み合わせ</h2>
        <p class="text-gray-500 mb-3">
          単品で食べるよりも複数のレシピを組み合わせることで食事のバランスも良くなります。<br />
          管理栄養士がおすすめするレシピ組み合わせを紹介します。
        </p>

        <div class="grid grid-cols-2 md:grid-cols-4 gap-3 items-stretch mb-5">
          <AtomsRecipeCard
            v-for="recipe in recipeData?.related_recipes_by_menu"
            :key="recipe.id"
            :old-identifier="recipe.old_identifier"
            :recipe-id="recipe.id"
            :filename="recipe.main_image"
            :energy="recipe.energy"
            :title="recipe.title"
            :tags="recipe.tags"
          />
        </div>
      </div>

      <OrganismsRecipeHistory class="my-10" />

      <OrganismsRecipeBottomAdsPc />
    </div>
  </div>
</template>
